query ApprovalTypes {
  approvalTypes(orderBy: APPROVAL_TYPE_ASC) {
    nodes {
      id
      approvalType
    }
  }
}